<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap class="mb-2 pb-2">
        <v-flex lg12>
          <direct-debit @setDirectDebit="setDirectDebit"></direct-debit>
        </v-flex>

        <v-flex lg12 class="mt-3">
          <v-title>Change of Lesse</v-title>
          <v-card>
            <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex sm6 md6 lg6>
                      <h3 class="pb-2">Current Status: New</h3>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex sm6 md6 lg6 style="text-align: right">
                      <vonex-date
                        ref="effectiveDate"
                        v-model="effectiveDate"
                        label="Effective Date"
                        :options="fieldConditions"
                        hide-details
                        lang="en-au"
                        name="effectiveDate"
                        placeholder="DD/MM/YYYY"
                        :rule="`required`"
                        editable
                      ></vonex-date>
                      <!-- <label class="title pr-2">Effective Date</label>
                    <date-picker
                      lang="en-au"
                      name="effectiveDate"
                      format="DD/MM/YYYY"
                      value-type="YYYY-MM-DD"
                      placeholder="DD/MM/YYYY"
                      v-model="effectiveDate"
                      v-validate="'required'"
                      editable
                      data-vv-validate-on="blur"
                    /> -->
                    </v-flex>

                    <v-flex sm12 md12 lg12 class="mt-3">
                      <h2 color="primary">Existing Customer Information</h2>
                    </v-flex>

                    <v-flex sm4 md4 lg4>
                      <vonex-text
                        ref="formerCustCompanyName"
                        v-model="formerCustomer.companyDetails.companyName"
                        :options="fieldConditions"
                        hide-details
                        label="Company Name"
                        type="text"
                        name="formerCustCompanyName"
                        outline
                        :rule="`required`"
                      ></vonex-text>
                      <!-- <v-text-field
                      label="Company Name"
                      type="text"
                      name="formerCustCompanyName"
                      v-validate="'required'"
                      v-model="formerCustomer.companyDetails.companyName"
                      outline
                    ></v-text-field> -->
                    </v-flex>
                    <v-flex sm4 md4 lg4>
                      <vonex-text
                        ref="formerCustName"
                        v-model="formerCustomer.firstName"
                        :options="fieldConditions"
                        hide-details
                        label="Contact Name"
                        type="text"
                        name="formerCustName"
                        :rule="`required`"
                        outline
                      ></vonex-text>
                      <!-- <v-text-field
                      label="Contact Name"
                      type="text"
                      name="formerCustName"
                      v-validate="'required'"
                      v-model="formerCustomer.firstName"
                      outline
                    ></v-text-field> -->
                    </v-flex>
                    <v-flex sm4 md4 lg4>
                      <vonex-text
                        ref="formerCustEmail"
                        v-model="formerCustomer.email"
                        :options="fieldConditions"
                        hide-details
                        label="Contact Email"
                        type="text"
                        name="formerCustEmail"
                        :rule="`required`"
                        outline
                      ></vonex-text>
                      <!-- <v-text-field
                      label="Contact Email"
                      type="text"
                      name="formerCustEmail"
                      v-validate="'required'"
                      v-model="formerCustomer.email"
                      outline
                    ></v-text-field> -->
                    </v-flex>

                    <v-flex sm12 md12 lg12>
                      <h2 color="primary">New Customer Information</h2>
                    </v-flex>

                    <v-flex sm4 md4 lg4>
                      <vonex-text
                        ref="newCustCompanyName"
                        v-model="newCustomer.companyDetails.companyName"
                        :options="fieldConditions"
                        hide-details
                        label="Company Name"
                        type="text"
                        name="newCustCompanyName"
                        :rule="`required`"
                        outline
                      ></vonex-text>
                      <!-- <v-text-field
                      label="Company Name"
                      type="text"
                      name="newCustCompanyName"
                      v-validate="'required'"
                      v-model="newCustomer.companyDetails.companyName"
                      outline
                    ></v-text-field> -->
                    </v-flex>
                    <v-flex sm4 md4 lg4>
                      <vonex-text
                        ref="newCustName"
                        v-model="newCustomer.firstName"
                        :options="fieldConditions"
                        hide-details
                        label="Contact Name"
                        type="text"
                        name="newCustName"
                        :rule="`required`"
                        outline
                      ></vonex-text>
                      <!-- <v-text-field
                      label="Contact Name"
                      type="text"
                      name="newCustName"
                      v-validate="'required'"
                      v-model="newCustomer.firstName"
                      outline
                    ></v-text-field> -->
                    </v-flex>
                    <v-flex sm4 md4 lg4>
                      <vonex-text
                        ref="newCustEmail"
                        v-model="newCustomer.email"
                        :options="fieldConditions"
                        hide-details
                        label="Contact Email"
                        type="text"
                        name="newCustEmail"
                        :rule="`required`"
                        outline
                      ></vonex-text>
                      <!-- <v-text-field
                      label="Contact Email"
                      type="text"
                      name="newCustEmail"
                      v-validate="'required'"
                      v-model="newCustomer.email"
                      outline
                    ></v-text-field> -->
                    </v-flex>

                    <v-flex sm12 md12 lg12>
                      <h2 color="primary">Select Services to Transfer</h2>
                    </v-flex>

                    <v-flex sm12 md12 lg12>
                      <v-data-table
                        v-model="selectedServices"
                        :headers="headers"
                        :items="items"
                        item-key="key"
                        :pagination.sync="pagination"
                        select-all
                        class="elevation-1"
                      >
                        <template v-slot:headers="props">
                          <td class="pb-2">
                            <vonex-checkbox
                              :input-value="props.all"
                              :indeterminate="props.indeterminate"
                              primary
                              hide-details
                              class="text-xs-left"
                              @click.stop="selectAll"
                            ></vonex-checkbox>
                            <!-- <v-checkbox
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.stop="selectAll"
                            class="text-xs-left"
                          ></v-checkbox> -->
                          </td>
                          <td
                            v-for="header in props.headers"
                            :key="header.text"
                            class="pb-2"
                          >
                            {{ header.text }}
                          </td>
                        </template>
                        <template v-slot:items="props">
                          <tr
                            :active="props.selected"
                            @click="props.selected = !props.selected"
                          >
                            <td>
                              <vonex-checkbox
                                :input-value="props.selected"
                                class="transferservice text-xs-left"
                                hide-details
                              ></vonex-checkbox>
                              <!-- <v-checkbox
                              :input-value="props.selected"
                              class="transferservice text-xs-left"
                              hide-details
                            ></v-checkbox> -->
                            </td>
                            <td>{{ props.item.type }}</td>
                            <td>{{ props.item.service }}</td>
                            <td>{{ props.item.plan }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>

                    <v-btn
                      v-if="changeLesse.orderID > 0 ? false : true"
                      color="primary"
                      class="pa-2 mt-2"
                      :disabled="hasDirectDebit ? false : true"
                      :loading="isProcessing"
                      @click="sendLesseRequest"
                    >
                      Send Signature Requests
                    </v-btn>
                    <v-btn
                      v-else
                      color="primary"
                      class="pa-2 mt-2"
                      :loading="isProcessing"
                      @click="sendLesseRequest"
                    >
                      Resend Signature Request
                    </v-btn>
                  </v-layout>
                </v-container>
              </v-card-text>
            </ValidationObserver>
          </v-card>
        </v-flex>
        <message-alert
          :component="$store.getters['orders/changeLessee/message']"
        ></message-alert>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import DirectDebit from '@/components/DirectDebit';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapChangeLesseeState } =
  createNamespacedHelpers(`orders/changeLessee`);
const { mapActions: mapIPVoiceActions } =
  createNamespacedHelpers(`orders/ipVoice`);
import moment from 'moment';
import { ChangeLessee } from '@/models/ChangeLessee';
export default {
  name: 'ChangeLessee',
  components: {
    DirectDebit,
  },
  data: () => ({
    selectedServices: [],
    effectiveDate: moment(new Date()).toISOString().slice(0, 10),
    pagination: { rowsPerPage: 15 },
    headers: [
      { text: 'Type', value: 'type', sortable: true },
      { text: 'Service', value: 'service', sortable: true },
      { text: 'Plan', value: 'plan', sortable: true },
    ],
    items: [],
    changeLesse: new ChangeLessee(),
    directDebit: {},
    hasDirectDebit: false,
    isProcessing: false,
  }),
  mounted() {
    let vm = this;

    this.$store.commit('orders/changeLessee/setCreateOnly', true);

    if (this.$store.state.orders.rows[0].orderID > 0)
      this.changeLesse.orderID = this.$store.state.orders.rows[0].orderID;

    vm.loadAllServices();
  },
  methods: {
    ...mapIPVoiceActions(['setMessage', 'getServices']),
    setDirectDebit(args) {
      if (!Object.values(args).some((x) => x === '')) {
        this.hasDirectDebit = true;
        this.directDebit = args;
      } else {
        this.hasDirectDebit = false;
      }
    },
    selectAll() {
      let vm = this;
      if (vm.selectedServices.length) vm.selectedServices = [];
      else vm.selectedServices = vm.items.slice();
    },
    loadAllServices() {
      let vm = this;
      if (!vm.formerCustomer || !vm.formerCustomer.ubAccountNo) return;
      vm.getServices(vm.formerCustomer.ubAccountNo).then((data) => {
        if (data && data.length > 0) {
          vm.setMessage({ message: 'Data loaded!', httpStatus: 200 });
        } else {
          vm.setMessage({
            message: 'no services!',
            httpStatus: 200,
          });
          vm.items = [];
        }
        vm.items = data;
        let count = 0;

        vm.items.forEach((x) => {
          x.key = count;
          count = count + 1;
        });

        vm.selectedServices = vm.items;
      });
    },
    sendLesseRequest() {
      this.isProcessing = true;
      this.changeLesse.dealerID = this.newCustomer.dealerID;
      this.changeLesse.formerCustomerID = this.formerCustomer.customerID;
      this.changeLesse.formerCustomerNo = this.formerCustomer.custNo;
      this.changeLesse.newCustomerID = this.newCustomer.customerID;
      this.changeLesse.services = this.selectedServices;
      this.changeLesse.status = 1;
      this.changeLesse.formerCustomer = this.formerCustomer;
      this.changeLesse.newCustomer = this.newCustomer;
      this.changeLesse.directDebit = JSON.parse(
        JSON.stringify(this.directDebit)
      );

      this.$store
        .dispatch('orders/changeLessee/createLesse', this.changeLesse)
        .then((data) => {
          this.$store
            .dispatch('orders/getOrder', data.data.orderID)
            .then(() => {
              this.changeLesse.orderID = data.data.orderID;
            });
          this.hasDirectDebit = false;
        })
        .catch((e) => {})
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
  computed: {
    ...mapChangeLesseeState(['newCustomer', 'formerCustomer']),
  },
};
</script>

<style>
.transferservice.v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin: 11px auto 0 !important;
}
</style>
